import React, { useEffect } from "react";
import { List } from "antd";
import Styles from "./Styles";
import { getDefaultProps } from "../../api/client";
import moment from "moment";
import ReactPlayer from "react-player";
import "./PopEventStatus.css";
import { isEmpty } from "../../utils/comm";

function PopEventStatus(props) {
  let evtCdData = [];
  let vData = [];
  let updateDt = "",
    equSn = "",
    equNo = "",
    evtTp = "",
    evtNm = "";
  let count = 0;
  if (props != null) {
    if (props.evtCdData != null && props.evtCdData.length > 0) {
      evtCdData = props.evtCdData;
    }

    if (props.mediaData != null && props.mediaData.length > 0) {
      /*
              미디어 타입 별 출력
              i > image
              v > video
            */
      vData = props.mediaData.filter((vItem) => vItem.mediaTp === "v");
      updateDt = props.mediaData[0].createDt ? moment(props.mediaData[0].createDt).format("YYYY-MM-DD HH:mm:ss") : "";
      equSn = props.mediaData[0].equSn;
      equNo = props.mediaData[0].equNo;
      evtTp = props.mediaData[0].evtTp;

      evtCdData.forEach((data) => {
        if (data.code === evtTp) {
          evtNm = data.codeNm;
        }
      });
    }
  }

  function callback(isComplete) {
    if (props != null && props.callback != null) {
      props.callback(isComplete);
    }
  }

  useEffect(() => {}, []);

  return (
    <Styles>
      <div style={{ display: "flex", height: "30px" }}>
        <p style={{ marginRight: "auto" }}>발생 일시</p>
        <p style={{ marginLeft: "auto" }}>{updateDt}</p>
      </div>
      <div style={{ display: "flex", height: "30px" }}>
        <p style={{ marginRight: "auto" }}>장비 ID</p>
        <p style={{ marginLeft: "auto" }}>{isEmpty(equSn) ? "" : isEmpty(equNo) ? equSn : equSn + "(" + equNo + ")"}</p>
      </div>
      <div style={{ display: "flex", height: "30px" }}>
        <p style={{ marginRight: "auto" }}>감지 이벤트</p>
        <p style={{ marginLeft: "auto" }}>{evtNm}</p>
      </div>

      <div className={"status-container"}>
        <List
          itemLayout='horizontal'
          dataSource={vData}
          renderItem={(item) => (
            <List.Item>
              <ReactPlayer
                url={getDefaultProps("fileUrl") + item.fileNm}
                controls={true}
                playing={false}
                onReady={() => {
                  const isComplete = vData.length === ++count;
                  callback(isComplete);
                }}
                width={"fit-content"}
              />
            </List.Item>
          )}
        />
      </div>
    </Styles>
  );
}

export default PopEventStatus;
